import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// src/index.js (top of file)
import { Buffer } from 'buffer';
window.Buffer = window.Buffer || Buffer;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);